import React from "react";
import { ColumnDef, CoreRow, Table } from "@tanstack/react-table";
import Checkbox from "../../Inputs/Checkbox";
import { useTableRowsSelectionState } from "../Tables/RowSelectionProvider";

export const SELECT_COLUMN_DEF_CONSTANTS = {
  id: "select",
  minSize: 50,
  size: 50,
};
const SelectColumnHeader = ({ table }: { table: Table<any> }) => {
  const { getHeaderCheckboxState, handleHeaderCheckboxChange } =
    useTableRowsSelectionState();

  const currentPageRowIds = table
    .getRowModel()
    .rows.map((row: CoreRow<any>["original"]) => row.id);
  const checkboxValue = getHeaderCheckboxState(currentPageRowIds);

  const handleChange = () => {
    handleHeaderCheckboxChange(table, currentPageRowIds, checkboxValue);
  };

  return (
    <div
      onClick={e => e.stopPropagation()}
      onMouseDown={e => e.stopPropagation()}
    >
      <Checkbox value={checkboxValue} onChange={handleChange} />
    </div>
  );
};

const SelectColumnCell = ({ row }: { row: CoreRow<any>["original"] }) => {
  const { getRowCheckboxState, handleRowCheckboxChange } =
    useTableRowsSelectionState();

  const checkboxValue = getRowCheckboxState(row);

  const handleChange = (checked: boolean) => {
    handleRowCheckboxChange(row, checked);
  };

  return (
    <Checkbox
      value={checkboxValue}
      disabled={!row.getCanSelect()}
      onChange={handleChange}
    />
  );
};

export const createSelectColumn = <T,>(): ColumnDef<T> => ({
  ...SELECT_COLUMN_DEF_CONSTANTS,
  header: SelectColumnHeader,
  cell: SelectColumnCell,
  meta: {
    isSticky: true,
  },
});
